import React from "react";
import { object } from "prop-types";
import { cloudinaryImageAdapter } from "../../sharedComponents/CloudinaryImageAdapter";
// eslint-disable-next-line import/no-cycle
import { SocialAndAppsSection } from "./SocialAndAppsSection";

const SocialAndAppsSectionConnector = ({ data }) => (
	<SocialAndAppsSection
		appsTitle={data.appsTitle}
		appIcon={data.appIcons}
		appsSubTitle={data.appsSubTitle}
		appsDescription={data.appsDescription}
		appsLinks={data.appsLinksIcons}
		appsButtons={data.appsLinksButtons}
		socialIcon={data.socialIcons}
		socialImage={{
			...cloudinaryImageAdapter({
				cloudinaryImage: data?.socialImage?.[0],
				desc: data?.title,
				title: data?.title,
			}),
		}}
		socialTitle={data.socialTitle}
		socialSubTitle={data.socialSubTitle}
		socialDescription={data.socialDescription}
		socialLinks={data.socialLinksIcons}
		socialButtons={data.socialLinksButtons}
		variant={data.variant}
	/>
);

SocialAndAppsSectionConnector.propTypes = {
	data: object.isRequired,
};
export default SocialAndAppsSectionConnector;
export { SocialAndAppsSectionConnector };
